import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { STATIC_ROOT } from '../../../constants';

import SvgComponent from '../../SvgComponent';
import LinkButtonComponent from '../../button/LinkButtonComponent';
import LogoutButtonComponent from '../../authentication/logout/LogoutButtonComponent';

class LoggedInComponent extends React.Component {
    render() {
        const { i18n } = this.props;
        return (
            <div className="flex-container-h flex-center-alt">
                <LinkButtonComponent
                    cssClass="connexion connected hidden-mobonly"
                    color="main"
                    to={PATH.ACCOUNT_JACKPOT_PATH}
                    name="headerAccountButton-toMyJackpot"
                    text={
                        <React.Fragment>
                            <SvgComponent
                                src={`${STATIC_ROOT}/connexion.svg`}
                                width="15"
                                height="15"
                            />
                            <span>{i18n.SEE_MY_ACCOUNT}</span>
                        </React.Fragment>
                    }
                />
                <LogoutButtonComponent className="hidden-mobonly logout">
                    {i18n.LOG_OUT}
                </LogoutButtonComponent>
            </div>
        );
    }
}

LoggedInComponent.propTypes = {
    i18n: PropTypes.object.isRequired
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        i18n: state.i18n.feature.header.MEMBER_NAV
    };
}

export default connect(mapStateToProps)(LoggedInComponent);



// WEBPACK FOOTER //
// ./src/components/header/membernav/LoggedInComponent.js